import {
  useLocation,
  useNavigate,
  useSearchParams as useRouterSearchParams,
} from "react-router";

export function useRouter() {
  const navigate = useNavigate();
  return {
    push(to: string) {
      navigate(to);
    },
    replace(to: string) {
      navigate(to, { replace: true });
    },
  };
}

export function useSearchParams(): URLSearchParams {
  return useRouterSearchParams()[0];
}

export function usePathname(): string {
  return useLocation().pathname;
}
